import classNames from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { ReactNode, useMemo } from 'react';

import {
	fiveImagesLayout as fiveImagesLayoutStyle,
	sixImagesLayout as sixImagesLayoutStyle,
	twoImagesLayout as twoImagesLayoutStyle,
} from './style.module.css';

export enum ImageGridLayout {
	TwoImages,
	FiveImages,
	SixImages,
}

export interface ImageGridProps<T> {
	layout?: ImageGridLayout;
	items: Array<T>;
	renderItem(item: T, index: number): ReactNode;
}

const defaultLayoutForItemLength = (length: number): ImageGridLayout | undefined => {
	if (length >= 6) return ImageGridLayout.SixImages;
	if (length >= 5) return ImageGridLayout.FiveImages;
	return ImageGridLayout.TwoImages;
};

export const ImageGrid = <T,>({ layout, items, renderItem }: ImageGridProps<T>): JSX.Element => {
	if (!Array.isArray(items)) return <></>;
	if (!renderItem) throw new Error('Missing renderItem for ImageGrid');
	layout = layout ?? defaultLayoutForItemLength(items.length);

	switch (layout) {
		case ImageGridLayout.TwoImages:
			return (
				<div className={twoImagesLayoutStyle}>
					{!!items[0] && renderItem(items[0], 0)}
					{!!items[1] && renderItem(items[1], 1)}
				</div>
			);

		case ImageGridLayout.FiveImages:
			return (
				<div className={fiveImagesLayoutStyle}>
					{!!items[0] && renderItem(items[0], 0)}
					{!!items[1] && renderItem(items[1], 1)}
					{!!items[2] && renderItem(items[2], 2)}
					{!!items[3] && renderItem(items[3], 3)}
					{!!items[4] && renderItem(items[4], 4)}
				</div>
			);

		case ImageGridLayout.SixImages:
			return (
				<div className={sixImagesLayoutStyle}>
					{!!items[0] && renderItem(items[0], 0)}
					{!!items[1] && renderItem(items[1], 1)}
					{!!items[2] && renderItem(items[2], 2)}
					{!!items[3] && renderItem(items[3], 3)}
					{!!items[4] && renderItem(items[4], 4)}
					{!!items[5] && renderItem(items[5], 5)}
				</div>
			);

		default:
			return <></>;
	}
};
